module.exports = "data:text/x-markdown;base64,VGhlIGRyYWdvbiBoYXMgdGhyZWUgd2Vha25lc3NlcywgdHJ5IHRvIGRlZmVhdCB0aGUgZHJhZ29uLgoKVGhpbmdzIHRoYXQgbWlnaHQgaGVscDoKKiBbSG93IGRvIHlvdSBraWxsIGEgZHJhZ29uP10oaHR0cHM6Ly93d3cucXVvcmEuY29tL0hvdy1kby15b3Uta2lsbC1hLWRyYWdvbikK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/dragon.md
// module id = 1365
// module chunks = 0